import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgClickOutsideDirective } from 'ng-click-outside2';

@Component({
  selector: 'app-smash-three-dots-dropdown',
  standalone: true,
  imports: [CommonModule, NgClickOutsideDirective, TranslateModule],
  templateUrl: './smash-three-dots-dropdown.component.html',
  styleUrl: './smash-three-dots-dropdown.component.scss'
})
export class SmashThreeDotsDropdownComponent {

  dropdownDisplayed = false;

  constructor() { }

  toggleDropdown(event: Event) {
    event.stopPropagation();
    this.dropdownDisplayed = !this.dropdownDisplayed;
  }

  closeDropdown() {
    this.dropdownDisplayed = false;
  }
}
